import React from 'react';
import { Row, Col, Card, Table, Button, Typography, Skeleton, Flex } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';

const { Text, Title } = Typography;

const RecentInvoicesSection = ({ loading, stats, navigate, invoiceColumns }) => (
  <Row gutter={[24, 24]} align="top">
    <Col xs={24} md={8}>
      <Title level={5} className="customer-dashboard-section-title">
        Recent Invoices
      </Title>
      <Text type="secondary" className="customer-dashboard-section-text">
        Your most recent invoice. Open the full list to see everything.
      </Text>
    </Col>
    <Col xs={24} md={16}>
      <Card
      variant="borderless"
      className="shadow-none border-none"
        size="small"
        extra={
          <Button
            type="link"
            icon={<ArrowRightOutlined />}
            onClick={() => navigate('/invoices')}
            style={{ padding: 0, fontWeight: 500 }}
          >
            View all
          </Button>
        }
        styles={{ body: { padding: 0 } }}
      >
        {loading ? (
          <Flex justify="center" style={{ padding: 24 }}>
            <Skeleton active paragraph={{ rows: 4 }} />
          </Flex>
        ) : (
          <Table
            dataSource={stats?.recent_activity?.last_invoice ? [stats.recent_activity.last_invoice] : []}
            columns={invoiceColumns}
            rowKey={(r) => r.public_id ?? r.id ?? 'inv'}
            pagination={false}
            scroll={{ x: 'max-content' }}
            size="small"
            locale={{ emptyText: 'No invoices yet' }}
            style={{ borderRadius: '0 0 8px 8px' }}
          />
        )}
      </Card>
    </Col>
  </Row>
);

export default RecentInvoicesSection;
